<div class="flex flex-col wrapper" *ngIf="openDialog === 'systemHealth'">
  <div dir="rtl">
    <mat-icon svgIcon="close" [mat-dialog-close]="null"></mat-icon>
  </div>
  <div class="flex flex-col">
    <div class="flex justify-start items-center mat-headline-3 mb-40 fw-700">{{'BYOB_DASHBOARD.DIALOG.SYSTEM_HEALTH' | transloco}}
    </div>
  </div>
  <div echarts [options]="systemHealthChartOptions" class="system-health"></div>
  <div class="flex flex-row items-center w-100-percent mt-20">
    <button class="white mr-8" (click)="getSystemHealthData('running')" [ngClass]="{'neutral-blue' : toggle === 'running'}">{{'BYOB_DASHBOARD.DIALOG.RUNNING'| transloco}} ({{running}})</button>
    <button class="white mr-8" (click)="getSystemHealthData('issue')" [ngClass]="{'neutral-blue' : toggle === 'issue'}">{{'BYOB_DASHBOARD.DIALOG.ISSUES'| transloco}} ({{issue}})</button>
    <button class="white" (click)="getSystemHealthData('down')" [ngClass]="{'neutral-blue' : toggle === 'down'}">{{'BYOB_DASHBOARD.DIALOG.DOWN'| transloco}} ({{down}})</button>
  </div>

  <div class="flex flex-row justify-between text-left mat-subtitle-2 fw-700 mt-70 mb-32 record-details labels">
    <div>{{'BYOB_DASHBOARD.DIALOG.SERVICE' | transloco}}</div>
    <div>{{'BYOB_DASHBOARD.DIALOG.LOB' | transloco}}</div>
    <div>{{'BYOB_DASHBOARD.DIALOG.TYPE' | transloco}}</div>
    <div>{{'BYOB_DASHBOARD.DIALOG.STATUS' | transloco}}</div>
    <div>{{'BYOB_DASHBOARD.DIALOG.DOWNTIME' | transloco}}</div>
    <div></div>
  </div>
  <div *ngFor="let result of systemHealthResult" class="flex flex-row justify-between text-left record-details mat-body-2 pt-20 pb-20">
    <div class="mat-subtitle-2 fw-700">{{result.service}}</div>
    <div>{{result.lob}}</div>
    <div>{{result.type? result.type : ''}}</div>
    <div class="status">{{result.status}}</div>
    <div class="down-time">{{result.time | date: 'dd MMM yyyy, h:mm a'}}</div>
    <div class="flex flex-row items-center">
      <a class="no-underline cursor-pointer mr-40">{{'BYOB_DASHBOARD.DIALOG.VIEW_TICKET' | transloco}}</a>
      <mat-icon class="icon icon-md color-accent" svgIcon="chat_bubble_outline"></mat-icon>
    </div>
  </div>
</div>

<div class="flex flex-col wrapper" *ngIf="openDialog === 'systemSecurity'">
  <div dir="rtl">
    <mat-icon svgIcon="close" [mat-dialog-close]="null"></mat-icon>
  </div>
  <div class="flex flex-col content-wrapper">
    <div class="flex justify-start items-center mat-headline-3 mb-40 fw-700">System Security</div>
  </div>
  <div echarts [options]="systemSecurityChartOptions" class="system-health"></div>
  <div class="flex flex-row items-center w-100-percent mt-20">
    <button class="white mr-8" (click)="getSystemSecurityData('all')" [ngClass]="{'neutral-blue' : securityToggle === 'all'}">All (10)</button>
    <button class="white mr-8" (click)="getSystemSecurityData('critical')" [ngClass]="{'neutral-blue' : securityToggle === 'critical'}">Critical (1)</button>
    <button class="white mr-8" (click)="getSystemSecurityData('high')" [ngClass]="{'neutral-blue' : securityToggle === 'high'}">High (2)</button>
    <button class="white mr-8" (click)="getSystemSecurityData('medium')" [ngClass]="{'neutral-blue' : securityToggle === 'medium'}">Medium (3)</button>
    <button class="white mr-8" (click)="getSystemSecurityData('low')" [ngClass]="{'neutral-blue' : securityToggle === 'low'}">Low (2)</button>
  </div>

  <div class="flex flex-row justify-between text-left mat-subtitle-2 fw-700 mt-70 mb-32 record-details labels">
    <div>SUBJECT</div>
    <div>SEVERITY</div>
    <div>ID</div>
    <div>DATE</div>
    <div class="links"></div>
  </div>
  <div *ngFor="let result of systemSecurityResult" class="flex flex-row justify-between text-left record-details mat-body-2 pt-20 pb-20">
    <div class="mat-subtitle-2 fw-700">{{result.subject}}</div>
    <div>{{result.severity}}</div>
    <div>{{result.ID}}</div>
    <div class="down-time">{{result.time | date: 'dd MMM yyyy, h:mm a'}}</div>
    <div class="flex flex-row items-center links">
      <a class="no-underline cursor-pointer mr-40">View in CVE.org</a>
      <a class="no-underline cursor-pointer mr-40">{{'BYOB_DASHBOARD.DIALOG.VIEW_TICKET' | transloco}}</a>
    </div>
  </div>
</div>

<div class="flex flex-col wrapper" *ngIf="openDialog === 'systemAvailability'">
  <div dir="rtl">
    <mat-icon name="close" [mat-dialog-close]="null"></mat-icon>
  </div>
  <div class="flex flex-row mb-90">
    <div class="flex items-center mat-headline-3 mb-0 fw-700">Service Availability</div>
    <button class="flex items-center rounded-button mat-headline-5 fw-700 ml-20 mb-0 mt-10">99.99%</button>
  </div>
  <div class="flex flex-row items-center w-100-percent mb-50">
    <button class="white mr-8 neutral-blue">All</button>
    <button class="white mr-8">Wealth</button>
    <button class="white mr-8">Retail</button>
    <button class="white mr-8">SME</button>
    <button class="white mr-8">Corporate</button>
    <button class="white mr-8">Universal</button>
  </div>
  <div class="flex flex-row justify-end mr-120">
    <div class="flex items-center">
      <img src="/assets/images/Line_95.png" >
      <div class="pl-10 pr-20">Availability</div>
      <img src="/assets/images/Line_94.png" >
      <div class="pl-10">SLA goal</div>
    </div>
  </div>
  <div echarts [options]="serviceAvailableChartOptions" class="system-health"></div>
</div>
